import { httpClient } from "../http/httpClient";

export interface Gender {
  id: number;
  nome: string;
}

export interface GenderResponse {
  data: Gender[];
}

export async function getGender() {
  const { data } = await httpClient.get<GenderResponse>("/crefaz/context/sexo");
  return data;
}
